/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Type of Assets consolidated for charge events. The values can be ESS, MACHINE, CHARGER, ENERGY_SOURCE and GHOST. By Default it is MACHINE.
 *
 */
export var ChargeEventSourceType;
(function (ChargeEventSourceType) {
    ChargeEventSourceType["MACHINE"] = "MACHINE";
    ChargeEventSourceType["ESS"] = "ESS";
    ChargeEventSourceType["CHARGER"] = "CHARGER";
    ChargeEventSourceType["ENERGY_SOURCE"] = "ENERGY_SOURCE";
    ChargeEventSourceType["GHOST"] = "GHOST";
})(ChargeEventSourceType || (ChargeEventSourceType = {}));
